<template>
    <div class="container-fluid" id="dvcrud">
        <div class="row">
            <div class="col-md-12">
                <breadcrumb v-bind:bcitens="itensbc" v-bind:mtdcancelar="mtdcancelaredicao"></breadcrumb>
            </div>
            <div class="col-md-12">
                <div id="pnlista" class="card" style="display: none;">
                    <div class="card-header"><span id="titlista">LISTAGEM DE {{ itensbc.item1.titulo }}</span>
                        <router-link to="/">
                            <button type="button" class="close" data-dismiss="modal" aria-label="Close"><span aria-hidden="true">&times;</span></button>
                        </router-link>
                    </div>
                    <div class="card-body" style="padding: 10px;">
                        <div class="row">
                            <div class="col-sm-4 col-md-2 col-lg-2">
                                <label for="cbopfiltro">Filtrar:</label>
                                <select name="cbopfiltro" class="form-control form-control-sm" id="cbopfiltro" v-model="pfiltro" @change="mtdlimpar_listagem()">
                                    <option value="0">Código</option>
                                    <option value="1">Descrição</option>
                                </select>
                            </div>
                            <div class="col-sm-8 col-md-4 col-lg-4">
                                <label for="edconteudopesq">Conteúdo da pesquisa:</label>
                                <input id="edconteudopesq" type="text" class="form-control form-control-sm" v-model="pconteudo" @keyup="mtdlimpar_listagem()">
                            </div>
                            <div class="col-6 col-sm-6 col-md-2 col-lg-2">
                                <label for="cbqtdreg">Registros:</label>
                                <select name="cbqtdreg" class="form-control form-control-sm" id="cbqtdreg" v-model="pqtdregistros" @change="mtdlimpar_listagem()">
                                    <option value="10">10</option>
                                    <option value="20">20</option>
                                    <option value="30">30</option>
                                    <option value="40">40</option>
                                    <option value="50">50</option>
                                    <option value="99999999999">Todos</option>
                                </select>
                            </div>
                            <div class="col-sm-12 col-md-2 col-lg-2">
                                <span class="lblselect2">Filial:</span>
                                <select id="cbfilialpesq2" data-placeholder="Selecione uma opção" data-allow-clear="true"
                                        style="width:100%;" v-model="pidfilial">
                                </select>
                            </div> 
                            <div class="col-6 col-sm-6 col-md-2 col-lg-2">
                                <button type="button" id="btlistar" class="btn btn-primary btn-sm btn-block" @click.prevent="mtdexecutapesquisa()"><i class="fa fa-search"></i> Listar</button>
                            </div>
                            <div class="col-md-12" style="margin-top: 10px;">
                                <vue-bootstrap4-table
                                        :rows="lstmensagens"
                                        :columns="columns"
                                        :config="config"
                                        :classes="classes">
                                    <template slot="empty-results">
                                        <div class="col-md-12 text-center">Sem dados para visualização</div>
                                    </template>
                                    <!-- ícones de ordenação da table -->
                                    <template slot="sort-asc-icon">
                                        <i class="fa-icones-ordenacao fa fa-sort-asc"></i>
                                    </template>
                                    <template slot="sort-desc-icon">
                                        <i class="fa-icones-ordenacao fa fa-sort-desc"></i>
                                    </template>
                                    <template slot="no-sort-icon">
                                        <i class="fa-icones-ordenacao fa fa-unsorted"></i>
                                    </template>                                    
                                    <!--  -->                                    
                                    <template slot="id_f" slot-scope="item">
                                        {{ item.row.id }}
                                    </template>
                                    <template slot="opcoes" slot-scope="item">
                                        <div class="d-flex">
                                            <button v-if="item.row.stmensagem != 'programado'" type="button" title="Visualizar detalhes" class="btn btn-info btn-sm btn-opcrud ajt-btn" @click.prevent="mtdvisualizar(item.row)"><i class="fa fa-eye"></i></button>
                                            <button v-else type="button" title="Alterar" class="btn btn-info btn-sm btn-opcrud ajt-btn" @click.prevent="mtdalterar(item.row)"><i class="fa fa-edit"></i></button>
                                            <button v-if="item.row.stmensagem != 'pausado' && item.row.stmensagem != 'processando'" type="button" title="Excluir" class="btn btn-danger btn-sm btn-opcrud ajt-btn" @click.prevent="mtdexcluir(item.row)"><i class="fa fa-trash"></i></button>
                                            <button v-if="item.row.stmensagem == 'processando'" type="button" title="Pausar" class="btn btn-success btn-sm btn-opcrud ajt-btn" @click.prevent="mtdconfirmapausa(item.row)"><i class="fa fa-pause"></i></button>
                                            <button v-if="item.row.stmensagem == 'pausado'" type="button" title="Retomar" class="btn btn-success btn-sm btn-opcrud ajt-btn" @click.prevent="mtdconfirmaretorno(item.row)"><i class="fa fa-play"></i></button>
                                            <button type="button" class="btn btn-primary btn-sm" @click.prevent="mtdmostrarmenu(item.row)" style="width: 35px;"><i class="fa fa-navicon"></i></button>
                                        </div>
                                    </template>
                                    <template slot="qtdenviadas_f" slot-scope="item">
                                        <div class="d-flex p-0 m-0" style="justify-content: center;">
                                            <div class="p-0" v-for="(item, index) in item.row.feedbackmensagens" style="margin-right: 5px;">
                                                <span class="badge badge-pill" :style="mtdclassificastatus(item.stenvio)">{{ item.stenvio }} {{ item.quantidade }}</span>
                                            </div>
                                        </div>
                                    </template>
                                    <template slot="tptitulos_f" slot-scope="item">
                                        {{ (parseInt(item.row.tptitulos) === 0 ? 'Emissão' : 'Vencimento') }}
                                    </template>
                                    <template slot="stmensagem_f" slot-scope="item">
                                        <span v-if="item.row.stmensagem == 'programado'" class="badge badge-pill badge-info" style="background-color:#007bff; font-size: 12px;">Programado</span>
                                        <span v-if="item.row.stmensagem == 'processando'" class="badge badge-pill badge-info" style=" font-size: 12px;">Em processamento</span>
                                        <span v-if="item.row.stmensagem == 'concluido'" class="badge badge-pill badge-success" style="background-color: #0acf97; font-size: 12px;">Concluído</span>
                                        <span v-if="item.row.stmensagem == 'concluido_com_falhas'" class="badge badge-pill badge-warning" style=" font-size: 12px; background-color: #ff9800;">Concluído com falhas</span>
                                        <span v-if="item.row.stmensagem == 'nada_a_enviar'" class="badge badge-pill badge-secondary" style=" font-size: 12px;">Nada a enviar</span>
                                        <span v-if="item.row.stmensagem == 'falha'" class="badge badge-pill badge-danger" style=" font-size: 12px;">Falha ao enviar</span>
                                        <span v-if="item.row.stmensagem == 'pausado'" class="badge badge-pill badge-secondary" style=" font-size: 12px;">Em pausa</span>
                                    </template>
                                </vue-bootstrap4-table>
                            </div>
                            <div class="col-md-12">
                                <ul class="list-group">
                                    <li class="list-group-item d-flex justify-content-between align-items-center" style="padding: 10px;">
                                        Registros
                                        <span class="badge badge-info badge-pill text-right bdg-qtd-reg-info">{{lstmensagens.length}}</span>
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>
                    <div class="card-footer" style="padding: 10px;">
                        <div class="row">
                            <div class="col-10 col-sm-10 col-md-10 col-lg-10" id="dvpaginacao">
                                <v-pagination
                                        v-model="pagina_atual"
                                        :page-count="pqtd_paginas"
                                        :classes="bootstrapPaginationClasses">
                                </v-pagination>
                            </div>
                            <!-- <div class="col-2 col-sm-2 col-md-2 col-lg-2">
                                <button type="button" class="btn btn-success btn-sm btn-block" @click.prevent="iniciarWhatsAppSignup()"><i class="fa fa-file"></i> Login with Facebook</button>
                            </div> -->
                            <div class="col-2 col-sm-2 col-md-2 col-lg-2">
                                <button type="button" class="btn btn-success btn-sm btn-block" @click.prevent="mtdnovo()"><i class="fa fa-file"></i> Novo</button>
                            </div>
                        </div>
                    </div>
                </div>
                <div id="pncadastro" class="card" style="display:none;">
                    <div class="card-header"><span>{{itensbc.item2.titulo}}</span>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close" @click.prevent="mtdcancelaredicao()"><span aria-hidden="true">&times;</span></button>
                    </div>
                    <div class="card-body" style="padding: 10px;">
                        <div class="row">
                            <div class="col-sm-12 col-md-2 col-lg-2">
                                <label for="edid">Código:</label>
                                <input type="text" class="form-control form-control-sm" id="edid" v-model="vid"
                                    maxlength="20" disabled/>
                            </div>
                            <div class="col-sm-12 col-md-7 col-lg-7">
                                <label for="eddescricao">*Descrição:</label>
                                <input type="text" v-model="vdescricao" v-bind:disabled="ativadesativa"
                                       class="form-control form-control-sm" id="eddescricao" maxlength="50">
                            </div>
                            <div class="col-sm-12 col-md-4 col-lg-3">
                                <span class="lblselect2">*Filial:</span>
                                <select id="cbfilial" v-model="vidfilial" v-bind:disabled="ativadesativa"
                                        data-placeholder="Selecione uma opção" data-allow-clear="true" style="width:100%;">
                                </select>
                            </div>
                            <div class="col-sm-12 col-md-1 col-lg-1" style="margin-bottom: 15px;">
                                <label for="cbstcliente">St. cliente:</label>
                                    <select class="form-control form-control-sm" id="cbstcliente" v-model="vstcliente" v-bind:disabled="ativadesativa">
                                        <option value="0">Ativo</option>
                                        <option value="1">Inativo</option>
                                        <option value="2">Todos</option>
                                    </select>
                            </div>
                            <div class="col-sm-12 col-md-2 col-lg-2" style="margin-bottom: 15px;">
                                <label for="cbtpfiltro">Aplicar filtro em:</label>
                                <select class="form-control form-control-sm" id="cbtpfiltro" v-model="vtpfiltro" v-bind:disabled="ativadesativa">
                                    <option value="0">Titulos</option>
                                    <option disabled value="1">Clientes (em breve)</option>
                                </select>
                            </div>
                            <!--filtros de titulos-->
                            <div class="col-sm-12 col-md-3 col-lg-3" >
                                <span class="lblselect2">Categoria:</span>
                                <select id="cbcategoriapesq" data-placeholder="Selecione uma categoria" data-allow-clear="true"
                                    v-model="vidcategoria" style="width:100%;" v-bind:disabled="ativadesativa">
                                </select>
                            </div>
                            <div class="col-sm-12 col-md-3 col-lg-3" >
                                <span class="lblselect2">Município:</span>
                                <select id="cbmunicipiopesq" data-placeholder="Selecione uma cidade" data-allow-clear="true"
                                    v-model="vidmunicipio" style="width:100%;" v-bind:disabled="ativadesativa">
                                </select>
                            </div>
                            <div class="col-sm-12 col-md-3 col-lg-3" v-show="vtpfiltro == '0'">
                                <span class="lblselect2">Cliente:</span>
                                <select id="cbclientepesq" data-placeholder="Selecione um cliente" data-allow-clear="true"
                                    v-model="vidcliente" style="width:100%;" v-bind:disabled="ativadesativa" >
                                </select>
                            </div>
                            <div class="col-sm-12 col-md-2 col-lg-2 " v-show="vtpfiltro == '0'"">
                                <label for="cbtpperiodo">Tp. Período:</label>
                                <select class="form-control form-control-sm" id="cbtpperiodo" v-model="vtpperiodo" v-bind:disabled="ativadesativa">
                                    <option value="0">Emissão</option>
                                    <option value="1">Vencimento</option>
                                </select>
                            </div>
                            <div class="col-sm-12 col-md-2 col-lg-2" v-show="vtpfiltro == '0'"">
                                    <label for="dtini">De:</label>
                                    <div class="input-group">
                                        <date-picker id="dtini" v-model="vperiodoinicio" class="form-control form-control-sm" v-bind:disabled="ativadesativa" :config="options"></date-picker>
                                        <div class="input-group-append">
                                            <span class="input-group-text"><i class="fa fa-calendar"></i></span>
                                        </div>								
                                    </div>
                                </div>
                                <div class="col-sm-12 col-md-2 col-lg-2" v-show="vtpfiltro == '0'">
                                    <label for="dtfim">Até:</label>
                                    <div class="input-group">
                                        <date-picker id="dtfim" v-model="vperiodofim" class="form-control form-control-sm" v-bind:disabled="ativadesativa" :config="options"></date-picker>
                                        <div class="input-group-append">
                                            <span class="input-group-text"><i class="fa fa-calendar"></i></span>
                                        </div>																			
                                    </div>
                              </div>
                              <!--filtro por clientes-->
                              <div class="col-sm-12 col-md-2 col-lg-2" v-show="vtpfiltro == '1'">
                                <label for="cbtpcliente">Tipo de cliente:</label>
                                <select class="form-control form-control-sm" id="cbtpcliente" v-model="vtpcliente" v-bind:disabled="ativadesativa">
                                    <option value="0">Todos</option>
                                    <option value="1">Com cashback</option>
                                </select>
                            </div>
                            <div class="col-sm-12 col-md-2 col-lg-2" v-show="vtpfiltro == '1'">
                                <label for="cbtpperiodo">Tp. Período:</label>
                                <select class="form-control form-control-sm" id="cbtpperiodo" v-model="vtpperiodo" v-bind:disabled="ativadesativa">
                                    <option value="0">Emissão</option>
                                    <option value="1">Vencimento</option>
                                </select>
                            </div>
                            <div class="col-sm-12 col-md-2 col-lg-2" v-show="vtpfiltro == '1'">
                                <label for="dtini">De:</label>
                                <div class="input-group">
                                    <date-picker id="dtini" v-model="vperiodoinicio" class="form-control form-control-sm" v-bind:disabled="ativadesativa" :config="options"></date-picker>
                                    <div class="input-group-append">
                                        <span class="input-group-text"><i class="fa fa-calendar"></i></span>
                                    </div>								
                                </div>
                            </div>
                            <div class="col-sm-12 col-md-2 col-lg-2" v-show="vtpfiltro == '1'">
                                <label for="dtfim">Até:</label>
                                <div class="input-group">
                                    <date-picker id="dtfim" v-model="vperiodofim" class="form-control form-control-sm" v-bind:disabled="ativadesativa" :config="options"></date-picker>
                                    <div class="input-group-append">
                                        <span class="input-group-text"><i class="fa fa-calendar"></i></span>
                                    </div>																			
                                </div>
                            </div>
                            <!-- Condições da mensagem-->
                            <div class="col-sm-12 col-md-2 col-lg-2">
                                <label for="dtenvio">Data envio:</label>
                                <div class="input-group">
                                    <date-picker id="dtenvio" v-model="vdtenvio" class="form-control form-control-sm" v-bind:disabled="ativadesativa" :config="options2"></date-picker>
                                    <div class="input-group-append">
                                        <span class="input-group-text"><i class="fa fa-calendar"></i></span>
                                    </div>								
                                </div>
                            </div>
                        </div>
                        <div class="row">
                            <!-- selecionando Tamplate -->
                            <div class="col-md-12" style="margin-top: 15px;">
                                <div class="card">
                                    <div class="card-header card-in text-center">Selecione a mensagem</div>
                                    <div class="card-body">
                                        <div class="row mb-3"> 
                                            <div class="col-sm-12 col-md-3 col-lg-3">
                                                <span class="lblselect2">*Filtro Filial:</span>
                                                <select id="cbffilial" v-model="fidfilial" v-bind:disabled="ativadesativa"
                                                        data-placeholder="Selecione uma opção" data-allow-clear="true" style="width:100%;">
                                                </select>
                                            </div>
                                            <div class="col-sm-12 col-md-4 col-lg-4">
                                                <span class="lblselect2">*Selecione o template:</span>
                                                <select id="cbmensagem" data-placeholder="Selecione um template" data-allow-clear="true"
                                                        style="width:100%;" v-model="vidtemplate" v-bind:disabled="ativadesativatemplate">
                                                </select>
                                                <!-- <button id="btnselecionatemplate" type="button" class="btn btn-primary btn-sm mt-3">Selecionar<icon class="fa fa-check"></icon></button> -->
                                            </div> 
                                        </div>
                                        <div class="row">
                                            <div class="col-sm-12 col-md-7 col-lg-7 text-align-center">
                                                <span class="lblselect2 text">Pré-visualização da mensagem:</span>
                                                <div>
                                                    <textarea type="text" v-model="vtextomsg" v-bind:disabled="ativadesativa"
                                                    class="form-control form-control-sm" id="edtextomsg" maxlength="1024" style="width: 100%; height: 500px;
                                                    font-family: 'Roboto', sans-serif; font-size: 16px; padding: 15px 60px; line-height: 1.6; border-radius: 8px; resize: none;" disabled></textarea>
                                                </div>
                                            </div>                                                                                                                        
                                        </div>
                                    </div>
                                </div>                                                 
                            </div>                                                          
                        </div>
                        </div>
                    <div class="card-footer">
                        <div class="row">
                            <div class="col-sm-8">
                                <h5 style="font-size: 16px; color: #545b62; margin-top: 5px;"><strong>Campos com asterisco(*) devem ser informados</strong>.</h5>
                            </div>
                                    <div class="col-sm-2">
                                <button id="btgravar" v-if="(opcrud == 1)" type="button" @click.prevent="mtdgravar()"
                                        v-bind:disabled="validou" class="btn btn-primary btn-sm"
                                        style="width:100%; margin-bottom:10px;"><i class="fa fa-check"></i> Gravar
                                </button>
                                <button id="btgravar" v-else-if="(opcrud == 2)" type="button" @click.prevent="mtdgravar()"
                                        v-bind:disabled="validou" class="btn btn-primary btn-sm"
                                        style="width:100%; margin-bottom:10px;"><i class="fa fa-check"></i> Alterar
                                </button>
                                <button id="btgravar" v-else-if="(opcrud == 3)" type="button" @click.prevent="mtdgravar()"
                                        v-bind:disabled="validou" class="btn btn-primary btn-sm"
                                        style="width:100%; margin-bottom:10px;"><i class="fa fa-check"></i> Excluir
                                </button>
                            </div>
                            <div class="col-sm-2">
                                <button type="button" @click.prevent="mtdcancelaredicao()" class="btn btn-secondary btn-sm" style="width:100%">
                                    <i class="fa fa-close"></i> Cancelar
                                </button>
                            </div>
                        </div>
                    </div>
                    </div>
                </div>
            </div>
            <!-- MODAL MENU -->
            <div class="modal fade" id="mdlmenu">
                <div class="modal-dialog modal-sm modal-dialog-centered">
                    <div class="modal-content">
                        <div class="modal-body">
                            <div class="row">
                                <div class="col-md-12">
                                    <ul class="list-group" style="cursor: pointer;">
                                        <li class="list-group-item font-weight-bold text-center active" style="font-size: 18px;">{{ (itemmensagemauto.id) }}</li>
                                        <button type="button" class="list-group-item list-group-item-action font-weight-bold" style="color: #6c757d;" @click.prevent="mtdconfirmaenvio(itemmensagemauto)" title="Enviar Mensagens Imediato" ><i class="fa fa-paper-plane"></i> ENVIAR AGORA</button>
                                        <button type="button" class="list-group-item list-group-item-action font-weight-bold" style="color: #6c757d;" @click.prevent="mtdclonar(itemmensagemauto)" title="Enviar Mensagens Imediato" ><i class="fa fa-copy"></i> CLONAR</button>
                                    </ul>
                                </div>
                            </div>
                        </div>
                        <div class="modal-footer" style="padding: 5px;">
                            <div class="container-fluid">
                                <div class="row">
                                    <div class="col-md-12 text-center">
                                        <button type="button" class="btn btn-secondary btn-sm" data-dismiss="modal" style="width: 150px;"><i class="fa fa-close"></i> Cancelar</button>
                                    </div>
                                </div>					
                            </div>
                        </div>				        
                    </div>
                </div>
            </div>
        </div>
</template>

<script>
    import BreadCrumb from '../components/cmpbreadcrumb.vue'
    import VueBootstrap4Table from 'vue-bootstrap4-table'
    import vPagination from 'vue-plain-pagination'
    import util from '../utilitarios/util.js'
    import { counter, icon } from '@fortawesome/fontawesome-svg-core';

    export default {
        name: 'cadmensagensautomaticas', //módulo renomeado cadcobrancasautomaticas > cadmensagensautomaticas
        components:{
            VueBootstrap4Table,
            vPagination,
            'breadcrumb' : BreadCrumb
        },
        data: function() {
            return {
                options: {
                    format           : 'DD/MM/YYYY',
                    useCurrent       : false,
                    locale           : 'pt-BR',
                },
                options2: {
                    format           : 'DD/MM/YYYY HH:mm:ss',
                    useCurrent       : false,
                    locale           : 'pt-BR',
                    sideBySide       : true,
                    minDate          : new Date(),
                },
                lstmensagens  : [],
                itemmensagemauto: {},
                pfiltro      : 1,
                pconteudo    : '',
                pqtdregistros: 10,
                pqtd_paginas : 1,
                pagina_atual : 1,
                pqtd_total_registros: 0,

                //variáveis template
                vidtemplate: null,
                vtextomsg:     '',

                //variáveis do crud
                opcrud              : 0,
                vid                 : '',
                vdescricao          : '',
                vidfilial           : null,
                pidfilial           : null,
                fidfilial           : null,
                vidcategoria        : null,
                vidmunicipio        : null,
                vstcliente          : 0,
                vtpperiodo          : 1,
                vperiodoinicio      : util.DataAtual(true),
                vperiodofim         : util.DataAtual(true),
                vdtenvio            : util.DataAtual(true),
                vtpfiltro           : '0',
                vtpcliente          : '0',
                vidcliente          : null,

                utodasfiliais 		: this.$store.state.usuario.todasfiliais,
                //variável para habilitação dos campos
                bootstrapPaginationClasses: {
                    ul: 'pagination pagination-sm',
                    li: 'page-item',
                    liActive: 'active',
                    liDisable: 'disabled',
                    button: 'page-link'
                },
                itensbc : {
                    item1 : {
                        titulo : 'MENSAGENS AUTOMÁTICAS',
                        ativo  : false
                    },
                    item2 : {
                        titulo : '',
                        ativo  : false
                    }
                },
                columns: [
                    {
                        label: 'Opções',
                        name : 'opcoes',
                        row_text_alignment: "text-center",
                        column_text_alignment: "text-center",
                        row_classes: "def-col-opcoes",
                        sort: false
                    },
                        {
                        label: "Código",
                        name: "id",
                        initial_sort : true,//acrescentar isso na coluna que for iniciar ordenado
                        initial_sort_order: 'desc',
                        sort: true,
                        slot_name: "id_f",
                        row_classes: "def-col-cod",
                    },
                    {
                        label: "Descrição",
                        name: "descricao",
                        initial_sort : true,//acrescentar isso na coluna que for iniciar ordenado
                        initial_sort_order: 'asc',
                        sort: true,
                        row_text_alignment: "text-left",
                        column_text_alignment: "text-left"
                    },
                    {
                        label: "Tp. Período",
                        name: "tptitulos",
                        sort: true,
                        row_text_alignment: "text-left",
                        column_text_alignment: "text-left",
                        slot_name: "tptitulos_f"
                    },
                    {
                        label: "De:",
                        name: "periodoinicio",
                        sort: true,
                        row_text_alignment: "text-left",
                        column_text_alignment: "text-left"
                    },
                    {
                        label: "Até:",
                        name: "periodofim",
                        sort: true,
                        row_text_alignment: "text-left",
                        column_text_alignment: "text-left"
                    },
                    {
                        label: "Dt. Programada:",
                        name: "datamensagem",
                        sort: true,
                        row_text_alignment: "text-left",
                        column_text_alignment: "text-left"
                    },
                    {
                        label: "Qtd. Envios:",
                        name: "qtdenvios",
                        sort: true,
                        row_text_alignment: "text-left",
                        column_text_alignment: "text-left",
                        slot_name: "qtdenviadas_f",
                        row_classes: "def-col-envios",
                    },
                    {
                        label: "Status",
                        name: "stmensagem",
                        sort: true,
                        row_text_alignment: "text-center",
                        column_text_alignment: "text-left",
                        slot_name: "stmensagem_f"
                    },
                ],
                config: {
                    pagination: false,
                    pagination_info: false,
                    card_mode: false,
                    global_search: {
                        visibility: false,
                    },
                    show_refresh_button : false,
                    show_reset_button : false
                },
                classes: {
                    table: "table-bordered table-striped table-sm"
                }
            }
        },
        methods:{
            mtdmostrarmenu(itemmensagemauto){				
				this.itemmensagemauto = itemmensagemauto;
				$('#mdlmenu').modal('show');
			},
            mtdselect2_def(){
                let vself = this;
                let sqliniusuario = parseInt(vself.utodasfiliais) === 0 ? 'select f.codfil, f.fantasia from tbfiliaisusuario fu left join tbfiliais f on f.codfil=fu.idfilial ' : 'select codfil, fantasia from tbfiliais ';
                let sqlfimusuario = parseInt(vself.utodasfiliais) === 0 ? 'where upper(f.fantasia) like upper("%@@%") and fu.idusuario='+vself.$store.state.usuario.id : 'where upper(fantasia) like upper("%@@%")';  
                $("#cbfilialpesq2").select2({
					id: function (e) {return e.codfil},
					ajax: {						
						url: vself.$store.state.configpaths.pathselect2sql,						
						dataType: 'json',
						delay: 250,
						data: function (params) {
							return {
								q		: params.term,
								idclientesac : vself.$store.state.filialpadrao.idcliente,
								sqlini	: sqliniusuario,
								sqlfim	: sqlfimusuario,
								cpid	: 'codfil',
								cpdesc	: 'fantasia'
							};
						},
						processResults: function (data) {
							return {
								results: data
							};
						},
						cache: true
					},
					minimumInputLength: 0,
					theme: 'bootstrap',
					language: "pt-BR",
					templateResult: util.formatResult,
					templateSelection: util.formatSelection
				}).change(function () {
					vself.pidfilial = $("#cbfilialpesq2").val();
					vself.mtdlimpar_listagem();
				});
                $("#cbfilial").select2({
					id: function (e) {return e.codfil},
					ajax: {						
						url: vself.$store.state.configpaths.pathselect2sql,						
						dataType: 'json',
						delay: 250,
						data: function (params) {
							return {
								q		: params.term,
								idclientesac : vself.$store.state.filialpadrao.idcliente,
								sqlini	: sqliniusuario,
								sqlfim	: sqlfimusuario,
								cpid	: 'codfil',
								cpdesc	: 'fantasia'
							};
						},
						processResults: function (data) {
							return {
								results: data
							};
						},
						cache: true
					},
					minimumInputLength: 0,
					theme: 'bootstrap',
					language: "pt-BR",
					templateResult: util.formatResult,
					templateSelection: util.formatSelection
				}).change(function () {
					vself.vidfilial = $("#cbfilial").val();
					vself.mtdlimpar_listagem();
				});
                $("#cbffilial").select2({
					id: function (e) {return e.codfil},
					ajax: {						
						url: vself.$store.state.configpaths.pathselect2sql,						
						dataType: 'json',
						delay: 250,
						data: function (params) {
							return {
								q		: params.term,
								idclientesac : vself.$store.state.filialpadrao.idcliente,
								sqlini	: sqliniusuario,
								sqlfim	: sqlfimusuario,
								cpid	: 'codfil',
								cpdesc	: 'fantasia'
							};
						},
						processResults: function (data) {
							return {
								results: data
							};
						},
						cache: true
					},
					minimumInputLength: 0,
					theme: 'bootstrap',
					language: "pt-BR",
					templateResult: util.formatResult,
					templateSelection: util.formatSelection
				}).change(function () {
					vself.fidfilial = $("#cbffilial").val();
					vself.mtdlimpar_listagem();
				});
				$("#cbcategoriapesq").select2({
					id: function (e) {return e.id},
					ajax: {
						url: vself.$store.state.configpaths.pathselect2,
						dataType: 'json',
						delay: 250,
						data: function (params) {
							return {
								q: params.term,
								idclientesac : vself.$store.state.filialpadrao.idcliente,
								tb: 'tbcategorias',
								c1: 'id',
								c2: 'descricao'
							};
						},
						processResults: function (data) {
							return {
								results: data
							};
						},
						cache: true
					},
					minimumInputLength: 0,
					theme: 'bootstrap',
					language: "pt-BR",
					templateResult: util.formatResult,
					templateSelection: util.formatSelection
				}).change(function () {
					vself.vidcategoria = $("#cbcategoriapesq").val();
				});
				$("#cbmunicipiopesq").select2({
					id: function (e) {return e.id},
					ajax: {
						url: vself.$store.state.configpaths.pathselect2,
						dataType: 'json',
						delay: 250,
						data: function (params) {
							return {
								q: params.term,
								idclientesac : vself.$store.state.filialpadrao.idcliente,
								tb: 'tbmunicipios',
								c1: 'id',
								c2: 'descricao'
							};
						},
						processResults: function (data) {
							return {
								results: data
							};
						},
						cache: true
					},
					minimumInputLength: 0,
					theme: 'bootstrap',
					language: "pt-BR",
					templateResult: util.formatResult,
					templateSelection: util.formatSelection
				}).change(function () {
					vself.vidmunicipio = $("#cbmunicipiopesq").val();
				});
                $("#cbclientepesq").select2({
					id: function (e) {return e.id},
					ajax: {
						url: vself.$store.state.configpaths.pathselect2,
						dataType: 'json',
						delay: 250,
						data: function (params) {
							return {
								q: params.term,
								idclientesac : vself.$store.state.filialpadrao.idcliente,
								tb: 'tbclientes',
								c1: 'id',
								c2: 'nome'
							};
						},
						processResults: function (data) {
							return {
								results: data
							};
						},
						cache: true
					},
					minimumInputLength: 1,
					theme: 'bootstrap',
					language: "pt-BR",
					templateResult: util.formatResult,
					templateSelection: util.formatSelection
				}).change(function () {
					vself.vidcliente = $("#cbclientepesq").val();
				});
                //select do template
                $("#cbmensagem").select2({
					id: function (e) {return e.id},
					ajax: {						
						url: vself.$store.state.configpaths.pathselect2sql,						
						dataType: 'json',
						delay: 250,
						data: function (params) {
							return {
								q		: params.term,
								idclientesac : vself.$store.state.filialpadrao.idcliente,
								sqlini	: 'SELECT t.id, t.descricao from tbtemplatesmensagens t',
								sqlfim	: 'where UPPER(t.descricao) like upper("%@@%") AND t.idfilial = '+vself.fidfilial,
								cpid	: 'id',
								cpdesc	: 'descricao'
							};
						},
						processResults: function (data) {
							return {
								results: data
							};
						},
						cache: true
					},
					minimumInputLength: 0,
					theme: 'bootstrap',
					language: "pt-BR",
					templateResult: util.formatResult,
					templateSelection: util.formatSelection
				}).change(function () {
					vself.vidtemplate = $("#cbmensagem").val();
                    vself.mtdvisualizatemplate(vself.vidtemplate);
				});
            },
            mtdenvioimediato(item){
                // console.log(item);
                var vself       = this;
                
                let loader      = this.$loading.show();
                let parametros  = [
                    {parametro: 'idclientesac', valor  : vself.$store.state.filialpadrao.idcliente},
                    {parametro: 'op',           valor  : 'envioimediato'},
                    {parametro: 'identificador', valor : item.id },
                    // {parametro: 'cobranca',     valor : JSON.stringify(cobranca)},
                ];
                let retorno           = util.reqaxios(parametros, 'post', vself.$store.state.usuario.adrsrv+'/controller/rtcadmensagensautomaticas.php');
                retorno.then(function (response) {

                    if($.isNumeric(response.data)){
                        vself.$toastr.s('registro processado com sucesso!', 'Sucesso!');
                    }else{
                        let tpret = response.data.substring(0,1);
                        switch (tpret) {
                            case 'I':
                                vself.$toastr.w(response.data.substring(4), 'Atenção!');
                                break;
                            case 'E': default:
                                vself.$toastr.e(response.data.substring(4), 'Erro!');
                                break;
                        }
                    }
                    vself.mtdexecutapesquisa();
                    loader.hide();
                    $('#mdlmenu').modal('hide');
                }).catch(function (response) {
                    loader.hide();
                    $('#mdlmenu').modal('hide');
                });
            },
            mtdfiltropesquisa(){
                let rfiltro = '';
                if (parseInt(this.pfiltro) === 0){
                    rfiltro = this.pconteudo === '' ? '' : ' and tma.id='+this.pconteudo;
                }else{
                    rfiltro = this.pconteudo === '' ? '' : ' and upper(tma.descricao) like upper("'+this.pconteudo+'%")';
                }

                if(this.pidfilial !== null) {                    
                    // feito na correria :( - Rodrigo 23/09/25
                    rfiltro = rfiltro + ' and tma.idfilial=' + this.pidfilial;
                }
                return rfiltro;
            },
            mtdexecutapesquisa(){
                var vself           = this;
                if (parseInt(vself.utodasfiliais) == 0){
                    if (vself.pidfilial === null || vself.pidfilial === ''){
                        vself.$toastr.i('Para o seu usuário, é necessário selecionar uma filial!', 'Atenção!');
                        $('#cbfilialpesq2').focus();
                        return;
                    }
                }
                let filtro          = vself.mtdfiltropesquisa();
                this.pagina_atual   = 1;
                let parametros      = [
                    {parametro: 'idclientesac', valor  : vself.$store.state.filialpadrao.idcliente},
                    {parametro: 'op',           valor  : 'qtdregistros'},
                    {parametro: 'filtro',       valor  : filtro}
                ];
                let retorno     = util.reqaxios(parametros, 'post', vself.$store.state.usuario.adrsrv+'/controller/rtcadmensagensautomaticas.php');
                retorno.then(function (response) {
                    vself.pqtd_total_registros = parseInt(response.data.qtdregistros);
                    let qtdpg                  = Math.ceil(vself.pqtd_total_registros / vself.pqtdregistros);
                    vself.pqtd_paginas         = qtdpg > 0 ? qtdpg : 1;
                    vself.mtdcarregamensagens(1);
                }).catch(function (response) {
                    alert('Erro ao consultar registros');
                });
            },
            mtdcarregamensagens(ipagina){
                var vself       = this;
                let loader      = this.$loading.show();
                let filtro      = vself.mtdfiltropesquisa();
                let parametros  = [
                    {parametro: 'idclientesac', valor  : vself.$store.state.filialpadrao.idcliente},
                    {parametro: 'op',           valor : 'listagem'},
                    {parametro: 'filtro',       valor : filtro},
                    {parametro: 'limit',        valor : vself.pqtdregistros},
                    {parametro: 'offset',       valor : (parseInt(ipagina) -1) * parseInt(vself.pqtdregistros)},
                ];
                let retorno           = util.reqaxios(parametros, 'post', vself.$store.state.usuario.adrsrv+'/controller/rtcadmensagensautomaticas.php');
                retorno.then(function (response) {
                    vself.lstmensagens = response.data;
                    loader.hide();
                }).catch(function (response) {
                    vself.lstmensagens = [];
                    loader.hide();
                });
            },
            resetarDados() {
                util.toTop();

                this.vid                = '';
                this.vdescricao         = '';
                $('#cbfilial').val(null).trigger('change');
                $('#cbcategoriapesq').val(null).trigger('change');
                $('#cbmunicipiopesq').val(null).trigger('change'); 
                $('#cbmensagem').val(null).trigger('change'); 
                $('#cbclientepesq').val(null).trigger('change'); 
                this.vstcliente         = 0;
                this.vtpperiodo         = 1;
                this.vperiodoinicio     = util.DataAtual(true);
                this.vperiodofim        = util.DataAtual(true);
                this.vdtenvio           = util.DataAtual(true, true);
                this.vtpcliente         = 0;
                this.vtpfiltro          = 0;
                this.vidcliente         = null;
            },
            mtddefault(){
                $('#pnlista').hide();
                this.resetarDados();
                $('#pncadastro').fadeIn(700);
                this.$nextTick(function () {
                    if (parseInt(this.opcrud) < 3) {
                        $('#eddescricao').focus();
                    } else {
                        $('#btgravar').focus();
                    }
                });
            },
            mtdpreparacrud(op) {
                let vself    = this;
                vself.opcrud = op;
                
                vself.mtddefault();
            },
            mtdnovo(){
                if (!util.opcaousuario('001Z.003Z.001Z', this.$store.state.perfilusuario)){
                    this.$toastr.i('Acesso não permitido para o usuário!', 'Informação!');
                }else {
                    this.itensbc.item2.titulo = 'INCLUSÃO DE MENSAGENS AUTOMÁTICAS';
                    this.itensbc.item1.ativo = true;
                    this.itensbc.item2.ativo = true;
                    this.ativadesativa = false;
                    this.mtdpreparacrud(1);
                }
            },
            mtdclonar(item){
                $('#mdlmenu').modal('hide');
                if (!util.opcaousuario('001Z.003Z.001Z', this.$store.state.perfilusuario)){
                    this.$toastr.i('Acesso não permitido para o usuário!', 'Informação!');
                }else {
                    this.itensbc.item2.titulo = 'INCLUSÃO DE MENSAGENS AUTOMÁTICAS';
                    this.itensbc.item1.ativo = true;
                    this.itensbc.item2.ativo = true;
                    this.ativadesativa = false;
                    this.mtdpreparacrud(1);
                    this.mtdlocalizaregistro(item.id);
                }
            },
            mtdpausar(item){
                var vself       = this;
                let loader      = this.$loading.show();
                let parametros  = [
                    {parametro: 'idclientesac', valor  : vself.$store.state.filialpadrao.idcliente},
                    {parametro: 'op',           valor  : 'pausarenvio'},
                    {parametro: 'identificador', valor : item.id },
                ];
                let retorno           = util.reqaxios(parametros, 'post', vself.$store.state.usuario.adrsrv+'/controller/rtcadmensagensautomaticas.php');
                retorno.then(function (response) {
                    if($.isNumeric(response.data)){
                        vself.$toastr.s('Envio pausado com sucesso!', 'Sucesso!');
                    }else{
                        let tpret = response.data.substring(0,1);
                        switch (tpret) {
                            case 'I':
                                vself.$toastr.w(response.data.substring(4), 'Atenção!');
                                break;
                            case 'E': default:
                                vself.$toastr.e(response.data.substring(4), 'Erro!');
                                break;
                        }
                    }
                    vself.mtdexecutapesquisa();
                    loader.hide();
                    $('#mdlmenu').modal('hide');
                }).catch(function (response) {
                    loader.hide();
                    $('#mdlmenu').modal('hide');
                });
            },
            mtdretornar(item){
                var vself       = this;
                let loader      = this.$loading.show();
                let parametros  = [
                    {parametro: 'idclientesac', valor  : vself.$store.state.filialpadrao.idcliente},
                    {parametro: 'op',           valor  : 'retornarenvio'},
                    {parametro: 'identificador', valor : item.id },
                ];
                let retorno           = util.reqaxios(parametros, 'post', vself.$store.state.usuario.adrsrv+'/controller/rtcadmensagensautomaticas.php');
                retorno.then(function (response) {
                    if($.isNumeric(response.data)){
                        vself.$toastr.s('Retomando envio com sucesso!', 'Sucesso!');
                    }else{
                        let tpret = response.data.substring(0,1);
                        switch (tpret) {
                            case 'I':
                                vself.$toastr.w(response.data.substring(4), 'Atenção!');
                                break;
                            case 'E': default:
                                vself.$toastr.e(response.data.substring(4), 'Erro!');
                                break;
                        }
                    }
                    vself.mtdexecutapesquisa();
                    loader.hide();
                    $('#mdlmenu').modal('hide');
                }).catch(function (response) {
                    loader.hide();
                    $('#mdlmenu').modal('hide');
                });
            },
            mtdvisualizar(item){
                $('#mdlmenu').modal('hide');
                
                this.itensbc.item2.titulo = 'DETALHES DE MENSAGENS AUTOMÁTICAS';
                this.itensbc.item1.ativo = true;
                this.itensbc.item2.ativo = true;
                this.ativadesativa = false;
                this.mtdpreparacrud(4);
                this.mtdlocalizaregistro(item.id);
            },
            mtdcancelaredicao(){
                this.itensbc.item1.ativo = false;
                this.itensbc.item2.ativo = false;
                $('#pncadastro').hide();
                $('#pnlista').fadeIn(700);
                $('#edconteudopesq').focus();
                setTimeout(function(){
                    util.toTop();
                }, 200);
            },
            mtdlimpar_listagem() {
                this.lstmensagens = [];
                this.pagina_atual = 1;
                this.filtro = '';
                this.pqtd_total_registros = 0;
                this.pqtd_paginas = 0;
            },
            mtdgravar(){
                let vself = this;
                $.confirm({
                    title: 'Confirmação!',
                    content: 'Confirma ' + vself.itensbc.item2.titulo + '?',
                    icon: 'fa fa-question-circle',
                    escapeKey: true,
                    backgroundDismiss: false,
                    escapeKey: 'nao',
                    type: 'dark',
                    typeAnimated: true,
                    buttons: {
                        sim: {
                            text: '<u>S</u>im',
                            keys: ['s', 'S'],
                            btnClass: 'btn-blue',
                            action: function () {
                                $('.btn-blue').prop('disabled', true);
                                vself.mtdregistro();
                            },
                        },
                        nao: {
                            text: '<u>N</u>ão',
                            keys: ['n', 'N'],
                            action: function () {
                                $('#btgravar').focus();
                            }
                        }
                    }
                });
            },
            mtdvisualizatemplate(idtemplate) {
                var vself = this;
                let loader = this.$loading.show();

                // Criação dos parâmetros para a requisição
                let parametros = [
                    {parametro: 'idclientesac', valor  : vself.$store.state.filialpadrao.idcliente},
                    {parametro: 'op', valor: 'visualizatemplate' },
                    {parametro: 'idtemplate', valor: idtemplate },
                ];

                // Realização da requisição
                let retorno = util.reqaxios(parametros,'post',vself.$store.state.usuario.adrsrv + '/controller/rtcadmensagensautomaticas.php'
                );retorno.then(function (response) {
                    vself.vtextomsg = response.data.data
                    loader.hide();
                }).catch(function (error) {
                    console.error('Erro na requisição:', error);
                    loader.hide();
                });
            },
            mtdconfirmaenvio(item){
                let vself  = this;
                let myitem = item;
                $.confirm({
                    title: 'Confirmação!',
                    content: '<big>Confirmar ENVIO IMEDIATO?</big><br><small>Essa ação anulará a data programada!</small>',
                    icon: 'fa fa-question-circle',
                    escapeKey: true,
                    backgroundDismiss: false,
                    escapeKey: 'nao',
                    type: 'dark',
                    typeAnimated: true,
                    buttons: {
                        sim: {
                            text: '<u>S</u>im',
                            keys: ['s', 'S'],
                            btnClass: 'btn-blue',
                            action: function () {
                                $('.btn-blue').prop('disabled', true);
                                vself.mtdenvioimediato(myitem);
                            },
                        },
                        nao: {
                            text: '<u>N</u>ão',
                            keys: ['n', 'N'],
                            action: function () {
                                $('#btgravar').focus();
                            }
                        }
                    }
                });
            },
            mtdconfirmapausa(item){
                let vself  = this;
                let myitem = item;
                $.confirm({
                    title: 'Confirmação!',
                    content: '<big>Confirmar PAUSAR o envio?</big><br><small>Essa ação irá pausar o envio das mensagens restantes!</small>',
                    icon: 'fa fa-question-circle',
                    escapeKey: true,
                    backgroundDismiss: false,
                    escapeKey: 'nao',
                    type: 'dark',
                    typeAnimated: true,
                    buttons: {
                        sim: {
                            text: '<u>S</u>im',
                            keys: ['s', 'S'],
                            btnClass: 'btn-blue',
                            action: function () {
                                $('.btn-blue').prop('disabled', true);
                                vself.mtdpausar(myitem);
                            },
                        },
                        nao: {
                            text: '<u>N</u>ão',
                            keys: ['n', 'N'],
                            action: function () {
                                $('#btgravar').focus();
                            }
                        }
                    }
                });
            },
            mtdconfirmaretorno(item){
                let vself  = this;
                let myitem = item;
                $.confirm({
                    title: 'Confirmação!',
                    content: '<big>Confirmar RETORNO do envio?</big><br><small>Essa ação irá retornar o envio das mensagens restantes!</small>',
                    icon: 'fa fa-question-circle',
                    escapeKey: true,
                    backgroundDismiss: false,
                    escapeKey: 'nao',
                    type: 'dark',
                    typeAnimated: true,
                    buttons: {
                        sim: {
                            text: '<u>S</u>im',
                            keys: ['s', 'S'],
                            btnClass: 'btn-blue',
                            action: function () {
                                $('.btn-blue').prop('disabled', true);
                                vself.mtdretornar(myitem);
                            },
                        },
                        nao: {
                            text: '<u>N</u>ão',
                            keys: ['n', 'N'],
                            action: function () {
                                $('#btgravar').focus();
                            }
                        }
                    }
                });
            },
            mtdlocalizaregistro(id){
                var vself       = this;
                let loader      = vself.$loading.show();
                let filtro      = ' and tma.id='+id;
                let parametros  = [
                    {parametro: 'op',           valor : 'listagem'},
                    {parametro: 'idclientesac', valor  : vself.$store.state.filialpadrao.idcliente},
                    {parametro: 'filtro',       valor : filtro},
                    {parametro: 'limit',        valor : 1},
                    {parametro: 'offset',       valor : 0},
                ];
                let retorno           = util.reqaxios(parametros, 'post', vself.$store.state.usuario.adrsrv+'/controller/rtcadmensagensautomaticas.php');
                retorno.then(function (response) {

                     loader.hide();
                     vself.mtdigualarcampos(response.data[0]);
                    if (parseInt(vself.opcrud) < 3){
                        $('#eddescricao').focus();
                    }else{
                        $('#btgravar').focus();
                    }
                }).catch(function (response) {
                    loader.hide();
                });
            },
            mtdalterar(item){
                if(item.stmensagem != 'programado'){
                    this.$toastr.i('Não é possivel alterar a mensagem após o envio!', 'Informação!');
                    return;
                }

                if (!util.opcaousuario('001Z.003Z.002Z', this.$store.state.perfilusuario)){
                    this.$toastr.i('Acesso não permitido para o usuário!', 'Informação!');
                }else {
                    this.itensbc.item2.titulo = 'ALTERAÇÃO DE MENSAGENS AUTOMÁTICAS';
                    this.itensbc.item1.ativo = true;
                    this.itensbc.item2.ativo = true;
                    this.ativadesativa = false;
                    this.mtdpreparacrud(2);
                    this.mtdlocalizaregistro(item.id);
                }
            },
            mtdexcluir(item){
                if(item.stmensagem != 'programado'){
                    this.$toastr.i('Você não tem permissão para excluir o histórico de um registro após o envio dele!', 'Informação!');
                    return;
                }
                if (!util.opcaousuario('001Z.003Z.003Z', this.$store.state.perfilusuario)){
                    this.$toastr.i('Acesso não permitido para o usuário!', 'Informação!');
                }else {
                    this.itensbc.item2.titulo = 'EXCLUSÃO DE MENSAGENS AUTOMÁTICAS';
                    this.itensbc.item1.ativo = true;
                    this.itensbc.item2.ativo = true;
                    this.ativadesativa = true;
                    this.mtdpreparacrud(3);
                    this.mtdlocalizaregistro(item.id);
                }
            },
            mtdigualarcampos(registro){
                if (parseInt(this.opcrud) === 1){
                    this.vid                = '';
                }else{
                    this.vid                = registro.id;
                }
                this.vdescricao          = registro.descricao;
                this.vstcliente          = registro.stclientetitulo;
                this.vtpperiodo          = registro.tptitulos;
                this.vperiodoinicio      = registro.periodoinicio;
                this.vperiodofim         = registro.periodofim;
                this.vdtenvio            = registro.datamensagem;
                this.vstmensagem         = registro.stmensagem;
                this.vidfilial           = registro.idfilial;
                this.vidtemplate         = registro.idtemplate  === 0 ? null : registro.idtemplate;;
                this.vidcategoria        = registro.idcategoria === 0 ? null : registro.idcategoria;
                this.vidmunicipio        = registro.idmunicipio === 0 ? null : registro.idmunicipio;
                this.vidcliente          = registro.idcliente   === 0 ? null : registro.idcliente;
                this.vtpcliente          = registro.tpcliente;
                this.vtpfiltro           = registro.tpfiltro;
                
                if (this.vidfilial !== null){
                    var deffil                = new Option(registro.descfil, registro.idfilial, true, true);
                $('#cbfilial').append(deffil).trigger('change');                
                }else{
                    $('#cbfilial').val(null).trigger('change');
                }
                if (this.vidcategoria !== null){
                    var defcategoria         = new Option(registro.desccategoria, registro.idcategoria, true, true);
                    $('#cbcategoriapesq').append(defcategoria).trigger('change');                
                }else{
                    $('#cbcategoriapesq').val(null).trigger('change');
                }
                if (this.vidmunicipio !== null){
                    var defmunicipio         = new Option(registro.descmunicipio, registro.idmunicipio, true, true);
                $('#cbmunicipiopesq').append(defmunicipio).trigger('change');                
                }else{
                    $('#cbmunicipiopesq').val(null).trigger('change');
                }
                if (this.vidtemplate !== null){
                    var deftemplate         = new Option(registro.desctemplate, registro.idtemplate, true, true);
                $('#cbmensagem').append(deftemplate).trigger('change');                
                }else{
                    $('#cbmensagem').val(null).trigger('change');
                }
                if (this.vidcliente !== null){
                    var defcliente         = new Option(registro.nomecliente, registro.idcliente, true, true);
                $('#cbclientepesq').append(defcliente).trigger('change');                
                }else{
                    $('#cbclientepesq').val(null).trigger('change');
                }
            },
            mtdregistro(){
                let vself  = this;
                let loader = vself.$loading.show();
                let registrocrud = {
                    id                    : this.vid,
                    descricao             : this.vdescricao,
                    stclientetitulo       : this.vstcliente,
                    tptitulos             : this.vtpperiodo,
                    periodoinicio         : this.vperiodoinicio,
                    periodofim            : this.vperiodofim,
                    datamensagem          : this.formatarDataHoraDB(this.vdtenvio),
                    idmunicipio           : this.vidmunicipio === null ? null : this.vidmunicipio,
                    idfilial              : this.vidfilial    === null ? null : this.vidfilial,
                    idcategoria           : this.vidcategoria === null ? null : this.vidcategoria,
                    idtemplate            : this.vidtemplate  === null ? null : this.vidtemplate,
                    idcliente             : this.vidcliente   === null ? null : this.vidcliente,
                    tpfiltro              : this.vtpfiltro,
                    tpcliente             : this.vtpcliente,
                };

                let parametros      = [
                    {parametro: 'idclientesac', valor : vself.$store.state.filialpadrao.idcliente},
                    {parametro: 'op',           valor : 'rotinacrud'},
                    {parametro: 'opcrud',       valor : vself.opcrud},
                    {parametro: 'registro',     valor : JSON.stringify(registrocrud)},
                    {parametro: 'idfilial',     valor : vself.$store.state.filialpadrao.codfil},
                    {parametro: 'idusuario',    valor : vself.$store.state.usuario.id},
                    {parametro: 'codop',        valor : parseInt(this.opcrud) === 1 ? '001Z.003Z.001Z' : parseInt(this.opcrud) === 2 ? '001Z.003Z.002Z' : '001Z.003Z.003Z'},
                ];
                let retorno     = util.reqaxios(parametros, 'post', vself.$store.state.usuario.adrsrv+'/controller/rtcadmensagensautomaticas.php');
                retorno.then(function (response) {
                    loader.hide();
                    if ($.isNumeric(response.data)){
                        vself.$toastr.s('Registro processado com sucesso!', 'Informação!');
                        vself.pfiltro       = 0;
                        vself.pconteudo     = parseInt(vself.opcrud) === 1 ? response.data : vself.vid;
                        vself.pqtd_paginas  = 1;
                        vself.mtdcancelaredicao();
                        vself.mtdcarregamensagens(1);
                    }else{
                        let tpret = response.data.substring(0,1);
                        switch (tpret) {
                            case 'I':
                                vself.$toastr.w(response.data.substring(4), 'Atenção!');
                                break;
                            case 'E': default:
                                vself.$toastr.e(response.data.substring(4), 'Erro!');
                                break;
                        }
                    }
                }).catch(function (response) {
                    loader.hide();
                    vself.$toastr.e('Erro ao processar o registo. Descrição do erro: '+response.message, 'Erro!');
                });
            },
            formatarDataHoraDB(data) {
                const [dataParte, horaParte] = data.split(' ');
                const [dia, mes, ano] = dataParte.split('/');
                return `${ano}-${mes}-${dia} ${horaParte}`;
            },
            HandleMessageEvent(event){
                if (event.origin !== "https://www.facebook.com" && event.origin !== "https://web.facebook.com") return;

                try {
                    const data = JSON.parse(event.data);
                    if (data.type === 'WA_EMBEDDED_SIGNUP') {
                        console.log('message event: ', data); // remove after testing
                        // your code goes here
                    }
                } catch (e) {
                    console.log('message event: ', event.data); // remove after testing
                    // your code goes here
                }
            },
            fbLoginCallback(response) {
                // Callback para login do Facebook
                if (response.authResponse) {
                    const code = response.authResponse.code;
                    console.log('Login Successful, Code: ', code);
                // Lógica para manipular o código
                } else {
                    console.log('Login Failed, Response: ', response);
                // Lógica para erro de login
                }
            },
            iniciarWhatsAppSignup() {
                FB.login(this.fbLoginCallback, {
                    config_id: '472918455610540', // Substitua pelo ID correto
                    response_type: 'code',
                    override_default_response_type: true,
                    extras: {
                        setup: {},
                        featureType: '',
                        sessionInfoVersion: '3',
                    },
                });
            },
            mtdclassificastatus(status){
                const prefixo = status;

                const mapaIcones = {
                    'NÃO ENVIADOS'   : 'background-color: #CC330D; color: white',
                    'ENVIADOS'     : 'background-color: #0ACF97; color: white;',
                    'PENDENTES'  : 'background-color: #5C8F94; color: white',
                };

                return mapaIcones[prefixo];
            }
            
        },
        mounted: function () {
            if (util.verificasessao(this)) {
                let vself = this;
                let loader = vself.$loading.show();
                let parametros = [
                    { parametro: 'op', valor: 'dadosusuario' },
                    { parametro: 'idclientesac', valor: vself.$store.state.usuario.idclientesac },
                    { parametro: 'idusuario', valor: vself.$store.state.usuario.id }
                ];
                let retorno = util.reqaxios(parametros, 'post', vself.$store.state.usuario.adrsrv + '/controller/rotinasusuario.php');
                retorno.then(function (response) {
                loader.hide();
                vself.$store.commit('MUDAR_PERFIL_USUARIO', response.data.perfilusu);
                if (util.opcaousuario('001Z.003Z', vself.$store.state.perfilusuario)) {
                    $('#pnlista').fadeIn(700);
                    vself.mtdexecutapesquisa();
                    vself.mtdselect2_def();

                    // === BLOCO DO AVISO DE MANUTENÇÃO ===
                    // const app = document.getElementById('app');
                    // if (app) {
                    //     app.style.filter = 'grayscale(100%)';
                    //     app.style.pointerEvents = 'none';
                    // }

                    // vself._aviso = document.createElement('div');
                    // vself._aviso.style.position = 'fixed';
                    // vself._aviso.style.top = '0';
                    // vself._aviso.style.left = '0';
                    // vself._aviso.style.width = '100%';
                    // vself._aviso.style.zIndex = '9999';
                    // vself._aviso.style.backgroundColor = '#ffcc00';
                    // vself._aviso.style.color = '#000';
                    // vself._aviso.style.textAlign = 'center';
                    // vself._aviso.style.fontSize = '16px';
                    // vself._aviso.style.padding = '10px';
                    // vself._aviso.style.boxShadow = '0 2px 5px rgba(0,0,0,0.3)';
                    // vself._aviso.style.pointerEvents = 'auto';
                    // vself._aviso.innerHTML = `
                    // 🔧 Este módulo está em manutenção temporária. Voltaremos em breve.
                    // <button id="btnVoltar" style="
                    //     margin-left:15px;
                    //     background:#000;
                    //     color:#fff;
                    //     border:none;
                    //     padding:5px 10px;
                    //     cursor:pointer;
                    //     border-radius:4px;
                    // ">Voltar</button>
                    // `;

                    // document.body.appendChild(vself._aviso);

                    // // evento do botão
                    // const btn = vself._aviso.querySelector('#btnVoltar');
                    // btn.addEventListener('click', () => {
                    //     if (app) {
                    //         app.style.filter = '';
                    //         app.style.pointerEvents = '';
                    //     }
                    //     if (vself._aviso) {
                    //         vself._aviso.remove();
                    //         vself._aviso = null;
                    //     }
                    //     util.gotoprincipal();
                    // });
                    // === FIM DO BLOCO ===

                } else {
                    vself.$toastr.i('Acesso não permitido para o usuário!', 'Informação!');
                    setTimeout(function () {
                        util.gotoprincipal();
                    }, 1000);
                }
                }).catch(function (response) {
                    loader.hide();
                    console.log(response.message);
                });
            }
        },
        computed:{
            validou() {
                return this.vdescricao  === '' || this.vidfilial === null || this.vidtemplate === null; 
            },
            ativadesativatemplate() {
                return this.opcrud === 3 || this.opcrud === 4 || this.fidfilial === null;
            },
            ativadesativa(){
                return this.opcrud === 3 || this.opcrud === 4;
            }
        },
        watch:{
            pagina_atual(val){
                this.mtdcarregamensagens(val);
            },
            fidfilial(val){
                let vself = this;
                $("#cbmensagem").val(null).trigger('change');
                $("#cbmensagem").select2({
					id: function (e) {return e.id},
					ajax: {						
						url: vself.$store.state.configpaths.pathselect2sql,						
						dataType: 'json',
						delay: 250,
						data: function (params) {
							return {
								q		: params.term,
								idclientesac : vself.$store.state.filialpadrao.idcliente,
								sqlini	: 'SELECT t.id, t.descricao from tbtemplatesmensagens t ',
								sqlfim	: ' where UPPER(t.descricao) like upper("%@@%") AND t.idfilial = '+vself.fidfilial,
								cpid	: 'id',
								cpdesc	: 'descricao'
							};
						},
						processResults: function (data) {
							return {
								results: data
							};
						},
						cache: true
					},
					minimumInputLength: 0,
					theme: 'bootstrap',
					language: "pt-BR",
					templateResult: util.formatResult,
					templateSelection: util.formatSelection
				}).change(function () {
					vself.vidtemplate = $("#cbmensagem").val();
                    if (vself.vidtemplate !== null) {
                        vself.mtdvisualizatemplate(vself.vidtemplate);
                    } else {
                        vself.vtextomsg = '';
                    }
				});
            }
        }
    }
</script>
<style>
    .def-col-cod{
        width: 80px !important;
    }
    #btclonarperfilusuario{
        cursor: pointer;
        font-weight: bold;
        font-size: 18px;
        position: relative;
        float: right;
        top: 5px;
        transition: .35s;
    }
    #btmarcartodosopusuario{
        font-weight: bold;
        font-size: 18px;
        padding-right: 10px;
        cursor: pointer;
        position: relative;
        float: right;
        top: 5px;
        transition: .35s;
    }
    #btmarcartodosopusuario:hover{
        color: #666666;
        transition: .35s;
    }

    #btmarcartodfiliais{
        font-weight: bold;
        font-size: 18px;
        padding-right: 10px;
        cursor: pointer;
        position: relative;
        float: right;
        top: 5px;
        transition: .35s;
    }
    #btmarcartodfiliais:hover{
        color: #666666;
        transition: .35s;
    }
    #btclonarperfilusuario:hover{
        color: #666666;
        transition: .35s;
    }
    #mensagensenviadas{
        color: #666666;
    }
</style>